export default __webpack_public_path__ + "static/media/product2.b7e901ec.jpg";